export type IdentityRole = "tenant_admin" | "tenant_user";

export interface IdentityMemberOut {
  id: string;
  tenant_id: string;
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  role: IdentityRole;
}

export interface IdentityMemberCreateIn {
  username: string;
  email: string;
  first_name: string;
  last_name: string;
  role: IdentityRole;
}

export type IdentityMemberUpdateIn = Partial<IdentityMemberCreateIn>;

export const IDENTITY_ROLES: ReadonlyArray<{ value: IdentityRole; label: string }> = [
  { value: "tenant_admin", label: "Tenant admin" },
  { value: "tenant_user", label: "Tenant user" },
];
